import * as React from 'react';
import Box from '@mui/material/Box';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import { useSelector } from 'react-redux';
import { RootState } from '../../globalStore/store';
import { Button, Typography, useMediaQuery, useTheme } from '@mui/material';
import CryptoJS from 'crypto-js';
import { useNavigate } from 'react-router-dom';

interface StepComponent {
  label: string;
  component: React.ReactNode;
}

interface CustomHorizontalStepperProps {
  steps: StepComponent[];
}

const CustomHorizontalStepper: React.FC<CustomHorizontalStepperProps> = ({ steps }) => {
  const activeStep = useSelector((state: RootState) => state.stepper.activeStep);
  const userName: string = useSelector((state: RootState) => state.user.userName);
  const password: string = useSelector((state: RootState) => state.user.password);
  const navigate = useNavigate();
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));

  const encryptData = (data: object): string => {
    const SECRET_KEY: string | undefined = process.env.REACT_APP_ENCRYPTION_KEY;
    const jsonString = JSON.stringify(data);
    if (!SECRET_KEY) {
      throw new Error("Environment variable REACT_APP_ENCRYPTION_KEY is not defined");
    }
    const encrypted = CryptoJS.AES.encrypt(jsonString, SECRET_KEY).toString();
    return encodeURIComponent(encrypted);
  };

  const handleNextStep = (redirect: string) => {
    if (userName && password) {
      const encryptedData = encryptData({ userName, password, redirect });
      const baseUrl = process.env.REACT_APP_OLD_URL as string;
      const hash = '#/login';
      const url = new URL(baseUrl);
      window.location.href = `${url.origin}${url.pathname}${hash}?data=${encryptedData}`;
    } else {
      navigate('/login');
    }
  };

  return (
    <Box sx={{ width: isSmallScreen ? '100%' : '350px'}}>
      <Stepper activeStep={activeStep} sx={{width: '100%'}} alternativeLabel>
        {steps.map((step, index) => (
          <Step key={step.label}>
            <StepLabel sx={{ flexDirection:'column' }}>{step.label}</StepLabel>
          </Step>
        ))}
      </Stepper>
      {activeStep === steps.length ? (
        <Box sx={{ textAlign: 'center', marginTop: '20px', display: 'flex', flexDirection: 'column', gap: '20px', alignItems: 'center' }}>
          <Typography variant="h6">Sikeres regisztráció!</Typography>
          <Typography variant="subtitle1">Készen is vagyunk, nézz szét eszközeink között!</Typography>
          <Button sx={{ width: '300px' }} variant="contained" onClick={() => { handleNextStep('/shop') }}>Eszközök megtekintése</Button>
          <Button sx={{ width: '300px', borderRadius: '30px', textTransform: 'none' }} variant="outlined" onClick={() => { handleNextStep('/dashboard') }}>Tovább az admin felületre</Button>
        </Box>
      ) : (
        steps[activeStep]?.component
      )}
    </Box>
  );
};

export default CustomHorizontalStepper;